import React, { memo } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import { useGmailRefresh } from 'core/hooks';
import { Colors } from 'services/ColorService';

import { IStudent } from '../parts';
import { SlackUserConfig } from '../../_detailShared/SlackUserConfig';
import { CommunicationsPanel } from '../../_detailShared/CommunicationsPanel';
import { NotesPanel } from '../../_detailShared/NotesPanel';

interface ICommunicationTabProps {
  student: IStudent;
}

/**
 * Student "Общение" tab (spec 0003 redesign) — the interaction hub: Slack
 * config + conversations (Slack DMs + email, read/reply) + notes. Tasks now
 * live in their own "Задачи" tab. The "refresh mail" button pulls the latest
 * Gmail on demand (same global action as on the dashboard, placed here where
 * the manager actually reads the student's correspondence).
 */
export const CommunicationTab = memo(({ student }: ICommunicationTabProps) => {
  const { t } = useTranslation();
  const { refresh, syncing } = useGmailRefresh();

  return (
    <div>
      <SlackUserConfig studentId={student.id} />
      <Bar>
        <RefreshButton type="button" disabled={syncing} onClick={refresh}>
          {t('pages.communications.syncGmail')}
        </RefreshButton>
      </Bar>
      <CommunicationsPanel studentId={student.id} />
      <NotesPanel studentId={student.id} />
    </div>
  );
});

CommunicationTab.displayName = 'CommunicationTab';

const Bar = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 12px;
`;

const RefreshButton = styled.button`
  border: 1px solid ${Colors.Blue};
  background: ${Colors.White};
  color: ${Colors.Blue};
  border-radius: 8px;
  padding: 7px 14px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;

  &:disabled {
    opacity: 0.5;
    cursor: default;
  }
`;
